import React from 'react';
import { FDStack } from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';

const useStyles = buildUseStyles('WizardProgressBar', (theme) => ({
  progressBarRoot: {
    height: '2px',
    width: '100%',
  },
  progressBarLeft: {
    backgroundColor: theme.palette.facet.colorSunset500,
  },
  progressBarRight: {
    backgroundColor: theme.palette.facet.stone600,
  },
}));

const WizardProgressBar = ({ progress = 0 }) => {
  const classes = useStyles();
  const leftFlex = progress / 100;
  const rightFlex = 1 - leftFlex;
  return (
    <FDStack direction={'row'} width={'100%'} height={2}>
      <div className={classNames(classes.progressBarRoot, classes.progressBarLeft)} style={{ flex: leftFlex }} />
      <div className={classNames(classes.progressBarRoot, classes.progressBarRight)} style={{ flex: rightFlex }} />
    </FDStack>
  );
};

export { WizardProgressBar };
